import { atom } from "recoil";

const appointmentsAtom = atom({
  key: "appointmentsAtom",
  default: [],
});

export default appointmentsAtom;